var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRubixWires5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 557,
    height: 852,
    viewBox: "0 0 557 852",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M554.47 289.05V818.2L499.67 849.85V320.69L554.47 289.05Z",
    fill: "#D7DCE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M554.47 289.05L499.67 320.69L2.5 33.64L57.31 2L554.47 289.05Z",
    fill: "#D7DCE0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M499.67 320.69V849.85L2.5 562.8V33.6401L499.67 320.69Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 33.6401V562.8L499.67 849.85V320.69L2.5 33.6401Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M499.67 320.69L554.47 289.05",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M499.67 849.85L554.47 818.2V289.05L57.31 2L2.5 33.64",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M419.418 466.83C426.888 471.14 432.958 481.66 432.958 490.28C432.958 494.59 431.438 497.64 428.978 499.06C426.548 500.47 423.148 500.26 419.408 498.1L343.118 454.06C335.628 449.73 329.578 439.26 329.578 430.61C329.578 426.3 331.098 423.28 333.528 421.85C335.988 420.43 339.358 420.63 343.118 422.8L419.408 466.84L419.418 466.83Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M405.278 522.18C412.748 526.49 418.818 536.98 418.818 545.63C418.818 549.94 417.298 552.96 414.838 554.38C412.378 555.77 409.008 555.58 405.268 553.42L198.868 434.25C191.378 429.92 185.328 419.45 185.328 410.82C185.328 406.48 186.848 403.46 189.278 402.03C191.738 400.64 195.138 400.85 198.868 403L405.268 522.17L405.278 522.18Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M394.03 642.7C401.5 647.01 407.57 657.5 407.57 666.13C407.57 670.47 406.05 673.49 403.59 674.91C401.16 676.32 397.76 676.11 394.02 673.95L356.29 652.16C348.82 647.85 342.75 637.36 342.75 628.71C342.75 624.4 344.27 621.38 346.73 619.96C349.16 618.55 352.56 618.76 356.3 620.92L394.03 642.71V642.7Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M381.18 571.77C388.65 576.08 394.72 586.6 394.72 595.22C394.72 599.53 393.2 602.58 390.74 603.97C388.28 605.39 384.91 605.19 381.17 603.04L222.96 511.7C215.49 507.39 209.42 496.87 209.42 488.25C209.42 483.94 210.94 480.89 213.4 479.5C215.86 478.08 219.23 478.28 222.97 480.43L381.18 571.77Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M378.77 379.87C386.24 384.18 392.31 394.7 392.31 403.32C392.31 407.63 390.79 410.65 388.33 412.07C385.87 413.49 382.5 413.29 378.76 411.14L247.06 335.1C239.59 330.79 233.52 320.27 233.52 311.65C233.52 307.34 235.04 304.32 237.5 302.9C239.96 301.48 243.33 301.68 247.07 303.83L378.77 379.87Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M308.9 593.55C316.37 597.86 322.44 608.35 322.44 616.98C322.44 621.32 320.92 624.34 318.46 625.76C316 627.15 312.63 626.96 308.89 624.8L222.97 575.19C215.5 570.88 209.43 560.39 209.43 551.74C209.43 547.43 210.95 544.41 213.41 542.99C215.87 541.6 219.24 541.79 222.98 543.95L308.9 593.56V593.55Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M294.438 394.67C301.908 398.98 307.978 409.5 307.978 418.12C307.978 422.43 306.458 425.48 303.998 426.9C301.538 428.29 298.168 428.1 294.428 425.94L227.778 387.46C220.308 383.15 214.238 372.66 214.238 364.01C214.238 359.7 215.758 356.68 218.218 355.26C220.678 353.84 224.048 354.04 227.788 356.19L294.438 394.67Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M119.609 453.21V512.75L68.0391 482.98V423.44L119.609 453.21Z",
    fill: "#459AA4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M119.609 335.49V395.03L68.0391 365.26V305.72L119.609 335.49Z",
    fill: "#FBB93E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M119.609 217.78V277.32L68.0391 247.55V188.01L119.609 217.78Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M119.609 277.32L68.0391 247.55V188.01L119.609 217.78V277.32Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M119.609 395.03L68.0391 365.26V305.72L119.609 335.49V395.03Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M119.609 512.75L68.0391 482.98V423.44L119.609 453.21V512.75Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M163.389 234.85L196.299 291.83L163.389 310.83",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M378.769 411.14L247.069 335.1C239.599 330.79 233.529 320.27 233.529 311.65C233.529 307.34 235.049 304.32 237.509 302.9C239.969 301.48 243.339 301.68 247.079 303.83L378.779 379.87C386.249 384.18 392.319 394.7 392.319 403.32C392.319 407.63 390.799 410.65 388.339 412.07C385.879 413.49 382.509 413.29 378.769 411.14Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M294.44 425.95L227.79 387.47C220.32 383.16 214.25 372.67 214.25 364.02C214.25 359.71 215.77 356.69 218.23 355.27C220.69 353.85 224.06 354.05 227.8 356.2L294.45 394.68C301.92 398.99 307.99 409.51 307.99 418.13C307.99 422.44 306.47 425.49 304.01 426.91C301.55 428.3 298.18 428.11 294.44 425.95Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M419.42 498.1L343.13 454.06C335.64 449.73 329.59 439.26 329.59 430.61C329.59 426.3 331.11 423.28 333.54 421.85C336 420.43 339.37 420.63 343.13 422.8L419.42 466.84C426.89 471.15 432.96 481.67 432.96 490.29C432.96 494.6 431.44 497.65 428.98 499.07C426.55 500.48 423.15 500.27 419.41 498.11L419.42 498.1Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M405.28 553.43L198.88 434.26C191.39 429.93 185.34 419.46 185.34 410.83C185.34 406.49 186.86 403.47 189.29 402.04C191.75 400.65 195.15 400.86 198.88 403.01L405.28 522.18C412.75 526.49 418.82 536.98 418.82 545.63C418.82 549.94 417.3 552.96 414.84 554.38C412.38 555.77 409.01 555.58 405.27 553.42L405.28 553.43Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M381.18 603.04L222.97 511.7C215.5 507.39 209.43 496.87 209.43 488.25C209.43 483.94 210.95 480.89 213.41 479.5C215.87 478.08 219.24 478.28 222.98 480.43L381.19 571.77C388.66 576.08 394.73 586.6 394.73 595.22C394.73 599.53 393.21 602.58 390.75 603.97C388.29 605.39 384.92 605.19 381.18 603.04Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M308.899 624.79L222.979 575.18C215.509 570.87 209.439 560.38 209.439 551.73C209.439 547.42 210.959 544.4 213.419 542.98C215.879 541.59 219.249 541.78 222.989 543.94L308.909 593.55C316.379 597.86 322.449 608.35 322.449 616.98C322.449 621.32 320.929 624.34 318.469 625.76C316.009 627.15 312.639 626.96 308.899 624.8V624.79Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M394.03 673.94L356.3 652.15C348.83 647.84 342.76 637.35 342.76 628.7C342.76 624.39 344.28 621.37 346.74 619.95C349.17 618.54 352.57 618.75 356.31 620.91L394.04 642.7C401.51 647.01 407.58 657.5 407.58 666.13C407.58 670.47 406.06 673.49 403.6 674.91C401.17 676.32 397.77 676.11 394.03 673.95V673.94Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubixWires5);
export default __webpack_public_path__ + "static/media/RubixWires5.b9fe66db19bb06a38652dc43acf71b52.svg";
export { ForwardRef as ReactComponent };